<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
    <div class="flex flex-row items-center">
        <h2 mat-dialog-title class="!pl-0 text-2xl !m-0 font-bold !text-blue-theme-color">OTP Verification</h2>
    </div>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center" mat-dialog-close>
        <mat-icon class="text-blue-theme-color text-xl">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0">
    <div class="w-full">
        <div class="flex mt-6 w-full gap-4 justify-center items-center flex-col">
            <img src="assets/images/ui/otp.png" class="w-[120px]" alt="">
            <span
                class="text-blue-theme-color text-center font-medium md:text-lg sm:text-base text-base !leading-6">Please
                enter the 6 OTP <br> sent to your moblie number</span>
            <div class="flex justify-center mt-4">
                <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
            </div>
        </div>
        <div id="recaptcha-container"></div>
        <div class="text-center">
            <button color="primary" (click)="resendOtp()" class="!bg-white-color !text-blue-theme-color"
                mat-flat-button>Resend</button>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="mt-2 !pb-5 !px-0 justify-center">
    <button color="primary" (click)="this.continue()"
        class="!bg-blue-theme-color md:!w-[130px] sm:!w-full !w-full !h-11 text-white-color"
        mat-flat-button>Verify</button>
</mat-dialog-actions>